import React from 'react';

function parseStyleString(styleString) {
  const styles = {};
  styleString.split(';').forEach(declaration => {
    const [property, value] = declaration.split(':').map(s => s.trim());
    if (property && value) {
      const camelCaseProperty = property.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
      styles[camelCaseProperty] = value;
    }
  });
  return styles;
}

function domToReact(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent;
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    const tagName = node.tagName.toLowerCase();
    const props = {};
    for (const attr of node.attributes) {
      if (attr.name === 'style') {
        props.style = parseStyleString(attr.value);
      } else if (attr.name === 'class') {
        props.className = attr.value;
      } else if (attr.name === 'for') {
        props.htmlFor = attr.value;
      } else {
        props[attr.name] = attr.value;
      }
    }
    const children = Array.from(node.childNodes).map(domToReact);
    // Optional: Map specific tags to custom components
    if (tagName === 'a') {
      return React.createElement('a', props, ...children); // Could use a custom Link component
    }
    return React.createElement(tagName, props, ...children);
  }
  return null;
}

export function HtmlToReact({ htmlString }) {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
}
